import { render } from "./MindMapTreeMenu.vue?vue&type=template&id=aff21972"
import script from "./MindMapTreeMenu.vue?vue&type=script&lang=js"
export * from "./MindMapTreeMenu.vue?vue&type=script&lang=js"

import "./MindMapTreeMenu.vue?vue&type=style&index=0&id=aff21972&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__